import { talentProfile } from '@itp/prisma-talent/generated/client';

export const calculateProfileScore = (profile: talentProfile) => {
  const scoreItems = {
    descriptionLong: profile?.description && profile?.description.length >= 100,
    descriptionShort: profile?.description && profile?.description.length < 100,
    education: Array.isArray(profile?.education) && profile?.education?.length > 0,
    experience: Array.isArray(profile?.experience) && profile?.experience?.length > 0,
    jobTitle: !!profile?.jobTitle,
    languages: Array.isArray(profile?.languages) && profile?.languages.length > 0,
    location: !!profile?.location,
    profileName: profile?.profileName && profile?.profileName.length > 0,
    profilePicture: !!profile?.profilePicture,
    rate: !!profile?.rateCurrency || !!profile?.monthlyRate || !!profile?.hourlyRate,
    skills: Array.isArray(profile?.skills) && profile?.skills?.length >= 6,
    totalExperience: !!profile?.totalExperience,
  };

  let score = 0;

  if (profile?.profileName && profile?.profileName.length > 0) {
    score += 1;
  }

  if (profile?.profilePicture) {
    score += 5;
  }

  if (profile?.jobTitle) {
    score += 1;
  }

  if (profile?.totalExperience) {
    score += 3;
  }

  if (profile?.description && profile?.description.length > 100) {
    score += 10;
  } else if (profile?.description && profile?.description.length > 0) {
    score += 5;
  }

  if (profile?.location) {
    score += 10;
  }

  if (profile?.rateCurrency || profile?.monthlyRate || profile?.hourlyRate) {
    score += 10;
  }

  if (Array.isArray(profile?.skills) && profile?.skills.length > 0) {
    const l = profile?.skills?.length > 6 ? 6 : profile?.skills?.length;
    score += l * 5;
  }

  if (Array.isArray(profile?.languages) && profile?.languages.length > 0) {
    score += 10;
  }

  if (Array.isArray(profile?.experience) && profile?.experience.length > 0) {
    score += 10;
  }

  if (Array.isArray(profile?.education) && profile?.education.length > 0) {
    score += 10;
  }

  return { profileScore: score, scoreItems };
};
